import { createSlice } from "@reduxjs/toolkit";

// Initial state for jobId
const initialState = {
  jobId: null,
};

// Create jobId slice
const jobIdSlice = createSlice({
  name: "jobId",
  initialState,
  reducers: {
    // Action to set jobId when a job is selected
    setJobId: (state, action) => {
      state.jobId = action.payload;
    },
    // Action to clear jobId when navigating away or checking in a job
    clearJobId: (state) => {
      state.jobId = null;
    },
  },
});

// Export the actions generated by createSlice
export const { setJobId, clearJobId } = jobIdSlice.actions;

// Selector to get the current jobId from state
export const selectJobId = (state) => state.jobId.jobId;

// Export the reducer to be included in the store
export default jobIdSlice.reducer;
